import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import type { Agreement } from '../types';

interface AgreementSelectorProps {
  agreements: Agreement[];
  onSelect: (agreement: Agreement) => void;
}

export function AgreementSelector({ agreements, onSelect }: AgreementSelectorProps) {
  const [selected, setSelected] = useState('');

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const agreement = agreements.find((a) => a.uuid === selected);
    if (agreement) onSelect(agreement);
  }

  return (
    <main className="space-y-4 px-4 py-6" id="main-content" role="main" aria-label="Conteúdo principal">
      <div>
        <h1 className="text-xl font-bold text-slate-900">Selecionar acordo</h1>
        <p className="mt-1 text-sm text-slate-500">Selecione um acordo para continuar.</p>
      </div>

      <div className="rounded-2xl border border-slate-200 bg-white p-5">
        <form aria-label="Seleção de acordo" onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              htmlFor="agreement-select"
              className="mb-1.5 block text-xs font-medium text-slate-500"
            >
              Acordo
            </label>
            <select
              id="agreement-select"
              value={selected}
              onChange={e => setSelected(e.target.value)}
              aria-label="Selecione um acordo"
              aria-required="true"
              required
              className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-900 outline-none focus:border-slate-400 focus:ring-1 focus:ring-slate-400"
            >
              <option value="" disabled>Selecione um acordo</option>
              {agreements.map(a => (
                <option key={a.uuid} value={a.uuid}>
                  {a.hashid} ({a.state})
                </option>
              ))}
            </select>
          </div>

          <Button
            type="submit"
            disabled={!selected}
            aria-label="Continuar com o acordo selecionado"
          >
            Continuar
          </Button>
        </form>
      </div>
    </main>
  );
}
